<template>

  <b-row>
    <b-col>
      <template>
        <b-button
          type="submit"
          class="mt-3"
          @click="submit">
          {{$t('button.save')}}
        </b-button>
      </template>
      <template>
        <b-button
          type="button"
          class="mt-3 ml-2"
          variant="outline-info"
          @click="redirect">
          {{$t('button.cancel')}}
        </b-button>
      </template>
    </b-col>

    <b-col class="d-flex flex-row justify-content-end">
      <template v-if="show_delete_button && delete_url">
        <b-button
          type="button"
          class="mt-3"
          @click="deleteItem">
          {{$t('button.delete')}}
        </b-button>
      </template>
    </b-col>

  </b-row>

</template>

<script>
  export default {
    props: {
      backUrl: {
        type: String
      },
      show_delete_button: {
        type: Boolean,
        default: false
      },
      delete_url: {
        type: String
      }
    },
    data () {
      return {
      }
    },
    methods: {
      submit () {
        this.$emit('submit')
      },
      redirect () {
        if (this.backUrl) {
          this.$router.push({path: this.backUrl})
        } else {
          this.goBack()
        }
      },
      deleteItem () {
        this.deleteData(this.delete_url, false, true)
      }
    }
  }
</script>